import jwtDecode from "jwt-decode"
import { useEffect, useState } from "react"
import { useMemo } from "react"
import { useSelector } from "react-redux"
import { getSubscriptionPath } from "../helpers/utility"


const useSubscriptionPermission = (module) => {
    const { token } = useSelector(state => state?.auth)
    const [isAllow, setIsAllow] = useState(false)
    const subscriptionAccess = useMemo(() => {
        if (token) {
            return jwtDecode(token)?.subscriptionPrivileges
        }
    }, [token])
    useEffect(() => {
        if (subscriptionAccess) {
            const permission = subscriptionAccess?.[getSubscriptionPath(module)]
            setIsAllow(permission)
        }
    }, [subscriptionAccess, module])

    return isAllow
}

export default useSubscriptionPermission